import { inject, Injectable, signal, Signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { DocumentTypeRepository } from '../repositories/document-type.repository';
import { DocumentType } from '../types/document-type';

@Injectable()
export class DocumentTypeService extends ReadonlyRepositoryCollectionService<
  DocumentType,
  DocumentType[],
  undefined
> {
  // TODO: once the repository moves to the sales-document-service, switch to a
  // customer-scoped param ({ customerId }) so the list reflects the document's
  // customer (GET /document-types?customerId=).
  override readonly params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(DocumentTypeRepository));
  }

  protected override getAll(result: DocumentType[] | null | undefined): DocumentType[] {
    return (result ?? []).filter((type) => type.category === 'SALES');
  }
}
